import {
  GRID_ACTIONS_COLUMN_TYPE,
  GRID_TREE_DATA_GROUPING_FIELD,
  GRID_CHECKBOX_SELECTION_FIELD,
} from '@mui/x-data-grid-pro';

export type CustomRenderer = {
  custom: typeof AvailableColumnTypes.custom;
  customFormatter: typeof AvailableColumnTypes.customFormatter;
  actions: typeof AvailableColumnTypes.actions;
  treeData: typeof AvailableColumnTypes.treeData;
};
export type GenericRenderer = {
  string: typeof AvailableColumnTypes.string;
  longString: typeof AvailableColumnTypes.longString;
  formattedTime: typeof AvailableColumnTypes.formattedTime;
  badges: typeof AvailableColumnTypes.badges;
  currency: typeof AvailableColumnTypes.currency;
  percentage: typeof AvailableColumnTypes.percentage;
  phoneNumber: typeof AvailableColumnTypes.phoneNumber;
  check: typeof AvailableColumnTypes.check;
  number: typeof AvailableColumnTypes.number;
};

class AvailableColumnTypesImpl implements GenericRenderer, CustomRenderer {
  readonly string = 'string';
  readonly longString = 'longString';
  readonly formattedTime = 'formattedTime';
  readonly badges = 'badges';
  readonly currency = 'currency';
  readonly custom = 'custom';
  readonly phoneNumber = 'phoneNumber';
  readonly customFormatter = 'customFormatter';
  readonly percentage = 'percentage';
  readonly number = 'number';
  readonly actions = GRID_ACTIONS_COLUMN_TYPE;
  readonly treeData = GRID_TREE_DATA_GROUPING_FIELD;
  readonly check = GRID_CHECKBOX_SELECTION_FIELD;
}

export const AvailableColumnTypes = new AvailableColumnTypesImpl();
